// Module
var code = `
<div class="object-data dk-col-small-12 dk-col-medium-6 dk-col-large-8">
   {{#images.0}}
   <a href="{{imagePath}}" class="lightbox-trigger">
      <span>{{textVariables.lightboxText}}</span>
      <figure>
         <img 
            {{#image_rights}}data-img-rights="{{textVariables.rights}}: {{image_owner}} / {{image_creator}} ({{image_rights}})"{{/image_rights}} 
            {{#image_text_override}}data-img-rights="{{textVariables.rights}}: {{image_text_override}}"{{/image_text_override}}
            src='{{imagePath}}' title='{{image_name}}' alt='{{image_description}}'>
      </figure>
   </a>
   {{/images.0}}
   <div class="data">
         {{^data}}
            {{#eventsObject}}
               <div>
                  {{#people}}
                        {{people_name}}{{#event_people_certain}} [circa]{{/event_people_certain}}
                  {{/people}}
                  {{#time}}
                     {{time_name}}{{#event_time_certain}} [circa]{{/event_time_certain}}
                  {{/time}}
               </div>
            {{/eventsObject}}
            {{#material}}
               <div>{{{material}}}</div><!--Material-->
            {{/material}}
      
            {{#dimensions}}
               <div>{{{dimensions}}}</div><!--größe-->
            {{/dimensions}}
         {{/data}}
         {{#data}}
            {{{data}}}
         {{/data}}
   </div>
</div>
<div class="object-info dk-col-small-12 dk-col-medium-6 dk-col-large-4">
   {{#eventsObject}}
      {{#people}}
      <div class="author">
         {{people_name}}
      </div>
      {{/people}}
   {{/eventsObject}}
   {{#name}}
   <div class="object-name">
      <h{{headlineLevel}} class="headline">
         <span>{{name}}</span>
      </h{{headlineLevel}}>
   </div>
   {{/name}}
   {{#description}}
   <div class="description">
      {{{description}}}
   </div>
   {{/description}}

   {{#text}}
   <div class="rte">
      {{{text}}}
   </div>
   {{/text}}
   {{#detailUrl}}
   <div class="more">
      <a href="{{detailUrl}}" aria-label="Details zu {{name}}">{{textVariables.detailLinkText}}</a>
   </div>
   {{/detailUrl}}
</div>`;
// Exports
module.exports = code;